import FormattedMessage from 'I18n/components/FormattedMessage';
import { Text } from 'foundations-components/components/Text';
import { Button } from 'foundations-components/transitional/components/Button';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { H2 } from 'foundations-components/transitional/components/H2';
import { Modal } from 'foundations-components/transitional/components/Modal';
import UsageTracker from '../../utils/UsageTracker';
import { getSessionStartTime } from './sessionTimeUtils';

// const VIEW_REGISTERED_EVENTS_TO = `${MYLEARNING_URL_FRAGMENT}?contentType=LIVE_EVENT`;
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function RegistrationConfirmationModal({
  isLive = false,
  isStartingSoon = false,
  joinUrl,
  liveEventId,
  liveEventTitle,
  onClose,
  session
}) {
  const handleJoinWorkshop = () => {
    UsageTracker.trackStandalone('Content Interaction', {
      action: 'live-event-join-session-click',
      contentType: 'LIVE_EVENT',
      contentId: liveEventId,
      contentName: liveEventTitle,
      sessionId: session.id,
      startTime: getSessionStartTime(session)
    });
  };
  if (isLive) {
    return /*#__PURE__*/_jsxs(Modal, {
      use: "success",
      width: 593,
      children: [/*#__PURE__*/_jsxs(DialogHeader, {
        children: [/*#__PURE__*/_jsx(H2, {
          children: isStartingSoon ? /*#__PURE__*/_jsx(FormattedMessage, {
            message: "academyComponents.liveEventOverviewModal.confirmationModal.startingSoonTitle"
          }) : /*#__PURE__*/_jsx(FormattedMessage, {
            message: "academyComponents.liveEventOverviewModal.confirmationModal.liveTitle"
          })
        }), /*#__PURE__*/_jsx(DialogCloseButton, {
          onClick: onClose
        })]
      }), /*#__PURE__*/_jsx(DialogBody, {
        children: /*#__PURE__*/_jsx(Text, {
          children: isStartingSoon ? /*#__PURE__*/_jsx(FormattedMessage, {
            message: "academyComponents.liveEventOverviewModal.confirmationModal.startingSoonEmailSent"
          }) : /*#__PURE__*/_jsx(FormattedMessage, {
            message: "academyComponents.liveEventOverviewModal.confirmationModal.liveEmailSent"
          })
        })
      }), /*#__PURE__*/_jsxs(DialogFooter, {
        children: [joinUrl ? /*#__PURE__*/_jsx(Button, {
          external: true,
          href: joinUrl,
          onClick: handleJoinWorkshop,
          target: "_blank",
          use: "primary",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "academyComponents.liveEventOverviewModal.confirmationModal.joinWorkshop"
          })
        }) : null, /*#__PURE__*/_jsx(Button, {
          onClick: onClose,
          use: "tertiary-light",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "academyComponents.liveEventOverviewModal.confirmationModal.close"
          })
        })]
      })]
    });
  }
  return /*#__PURE__*/_jsxs(Modal, {
    use: "success",
    width: 593,
    children: [/*#__PURE__*/_jsxs(DialogHeader, {
      children: [/*#__PURE__*/_jsx(H2, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "academyComponents.liveEventOverviewModal.confirmationModal.title"
        })
      }), /*#__PURE__*/_jsx(DialogCloseButton, {
        onClick: onClose
      })]
    }), /*#__PURE__*/_jsxs(DialogBody, {
      children: [/*#__PURE__*/_jsx(Text, {
        marginBlockEnd: "200",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "academyComponents.liveEventOverviewModal.confirmationModal.emailSent",
          options: {
            eventTitle: liveEventTitle
          }
        })
      }), /*#__PURE__*/_jsx(Text, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "academyComponents.liveEventOverviewModal.confirmationModal.addToCalendar"
        })
      })]
    }), /*#__PURE__*/_jsx(DialogFooter, {
      children: /*#__PURE__*/_jsx(Button, {
        onClick: onClose,
        use: "secondary",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "academyComponents.liveEventOverviewModal.confirmationModal.close"
        })
      })
    })]
  });
}